import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { StatusAPIResponse, TaxpayerInfo } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { ActionApiEvResponse, ChargingJobsHistory, CreateTransactionResponse, EvChargerHistoryInfo, EvChargingInvoiceResponse, EvChargingJob, EvChargingStopPayload, EvStartChargePayload, EvStartChargeResponse, EvStopChargeResponse, ParkingTransactionEVDto, ScanQREntriesPayload, StationChargingResponse } from "../../../models/ev.model";

@Injectable({
  providedIn: 'root',
})

export class ApiEvChargerService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  getParkingEVUser(
    uid: string,
    token: string,
  ): Observable<ParkingTransactionEVDto[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/GetParkingEVUser';
    const params = new HttpParams().set('Uid', uid);

    console.log(
      '📨 Sent Api EV Charger user : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<ParkingTransactionEVDto[]>(url, {
      headers,
      params,
    });
  }

  sentCheckStationChangerByQrCode(
    qrCode: string,
    token: string,
  ): Observable<StationChargingResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/CheckStationChangerByQrCode';
    const params = new HttpParams().set('qrCode', qrCode);
    console.log(
      '📨 Sent Api Check Station Changer By QrCode : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<StationChargingResponse>(url, {
      headers,
      params,
    });
  }


  sentEV_EntriesByQRCode(
    payload: ScanQREntriesPayload,
    token: string,
  ): Observable<ActionApiEvResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/EV_EntriesByQRCode';
    console.log('📨 Sent Api EV Entries By QrCode : ', url, headers, payload);
    return this.http.post<ActionApiEvResponse>(url, payload, {
      headers,
    });
  }

  getCityParkingInvoiceInfo(
    uid: string,
    token: string,
  ): Observable<EvChargingInvoiceResponse[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/getCityParkingInvoiceInfo';
    const params = new HttpParams().set('Uid', uid);
    return this.http.get<EvChargingInvoiceResponse[]>(url, {
      headers,
      params,
    });
  }


  getInfoEvChargerDetailByJobId(
    historyUuid: string,
    uid: string,
    token: string,
  ): Observable<EvChargingJob> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/GetInfoEvChargerDetailByJobId';
    const params = new HttpParams().set('jobId', historyUuid).set('uid', uid);

    console.log(
      '📨 Sent Api EV ChargerDetailByJobId : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<EvChargingJob>(url, {
      headers,
      params: params,
    });
  }

  sentApiStatusStartEvCharger(
    token: string,
    payload: EvStartChargePayload,
  ): Observable<EvStartChargeResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/cityparking-ev-start';

    console.log(
      '📨 Sent Api EV start Charger : ',
      url,
      headers,
      JSON.stringify(payload),
    );
    return this.http.post<EvStartChargeResponse>(url, payload, {
      headers,
    });
  }
  sentApiStatusStopEvCharger(
    token: string,
    payload: EvChargingStopPayload,
  ): Observable<EvStopChargeResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const url = `${this.tokenUrl}/cityparking-ev-api/cityparking-ev-stop`;

    console.log('📨 Sent Api EV stop Charger : ', url, headers, payload);

    return this.http.post<EvStopChargeResponse>(url, payload, {
      headers,
    });
  }





  getInfoEvChargerByJobId(
    historyUuid: string,
    uid: string,
    token: string,
  ): Observable<EvChargerHistoryInfo> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/GetInfoEvChargerByJobId';
    const params = new HttpParams().set('jobId', historyUuid).set('uid', uid);
    console.log(
      '📨 Sent Api EV ChargerByJobID : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<EvChargerHistoryInfo>(url, {
      headers,
      params,
    });
  }

  getChargingJobsHistory(
    uid: string,
    token: string,
  ): Observable<ChargingJobsHistory[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/cityparking-ev-api/GetChargingJobsHistory';
    const params = new HttpParams().set('Uid', uid);
    return this.http.get<ChargingJobsHistory[]>(url, {
      headers,
      params,
    });
  }
}
